import moment from "moment";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { fromDate } from "../../reducers/workOrdersReducer";

export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("start")) {
			searchParams.set("start", encodeURIComponent(fromDate.toJSON()));
			shouldUpdate = true;
		}

		if (!searchParams.has("end")) {
			searchParams.set(
				"end",
				encodeURIComponent(
					moment().hour(23).minute(59).second(59).toDate().toJSON(),
				),
			);
			shouldUpdate = true;
		}

		if (!searchParams.has("status")) {
			searchParams.set("status", "O");
			shouldUpdate = true;
		}

		if (!searchParams.has("type")) {
			searchParams.set("type", "A");
			shouldUpdate = true;
		}

		if (!searchParams.has("craft")) {
			searchParams.set("craft", "A");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
